import React, { forwardRef, memo } from 'react'

import AlertIconUrl from '@/assets/alert.svg'
import ArrowLeftThinIconUrl from '@/assets/arrow-left-thin.svg'
import ArrowRightThinIconUrl from '@/assets/arrow-right-thin.svg'
import CarryOnIncludedIconUrl from '@/assets/carry_on_included.svg'
import CarryOnNotIncludedIconUrl from '@/assets/carry_on_not_included.svg'
import CheckCurvyIconUrl from '@/assets/check-curvy.svg'
import CheckIconUrl from '@/assets/checked.svg'
import ChevronDownUrl from '@/assets/chevron-down.svg'
import ClipIconUrl from '@/assets/clip.svg'
import CreditCardIconUrl from '@/assets/credit-card-basic.svg'
import CrossIconUrl from '@/assets/cross.svg'
import DollarCircleIconUrl from '@/assets/dollar-circle.svg'
import DollarIconUrl from '@/assets/dollar.svg'
import GearIconUrl from '@/assets/gear.svg'
import ClockIconUrl from '@/assets/icons/clock.svg'
import FilterIconUrl from '@/assets/icons/filter.svg'
import FlightIconUrl from '@/assets/icons/flight.svg'
import LinkIconUrl from '@/assets/icons/link.svg'
import LuggageIconUrl from '@/assets/icons/luggage.svg'
import ShowIconUrl from '@/assets/icons/show.svg'
import TrainsIconUrl from '@/assets/icons/trains.svg'
import MockIconUrl from '@/assets/itinerary_luggage_remove.svg'
import MembershipIconUrl from '@/assets/membership.svg'
import RoundCheckIconUrl from '@/assets/round-check.svg'
import SortIconUrl from '@/assets/sort.svg'
import StopIconUrl from '@/assets/stop.svg'
import TicketIconUrl from '@/assets/ticket.svg'
import { Icon, IconSize, IProps as SvgIconProps } from '@/atoms/SvgIcon/SvgIcon'
import DetailsIconUrl from '@/refactor/assets/actions/details.svg'
import DownloadIconUrl from '@/refactor/assets/actions/download.svg'
import LinkRoundIconUrl from '@/refactor/assets/actions/link.svg'
import BeverageIconUrl from '@/refactor/assets/flight/bar.svg'
import EntertainIconUrl from '@/refactor/assets/flight/entertainment.svg'
import MealIconUrl from '@/refactor/assets/flight/meal.svg'
import PowerIconUrl from '@/refactor/assets/flight/power.svg'
import WiFiIconUrl from '@/refactor/assets/flight/wifi.svg'
import CardIconUrl from '@/refactor/assets/icons/card.svg'
import ChargeDateUrl from '@/refactor/assets/icons/charge-date.svg'
import FeeIdUrl from '@/refactor/assets/icons/double-coin.svg'
import EnvelopClosedIconUrl from '@/refactor/assets/icons/envelope-closed.svg'
import HourGlassUrl from '@/refactor/assets/icons/hourglass.svg'
import InfoIconUrl from '@/refactor/assets/icons/info.svg'
import LoyaltyIconUrl from '@/refactor/assets/icons/loyalty.svg'
import QuestionCircleIconUrl from '@/refactor/assets/icons/question-circle.svg'
import RefundReportsUrl from '@/refactor/assets/icons/refund-report.svg'
import InPolicyIconUrl from '@/refactor/assets/icons/star_checked.svg'
import UtensilsIconUrl from '@/refactor/assets/icons/utensils.svg'
import ManIconUrl from '@/refactor/assets/people/man.svg'
import * as colors from '@/refactor/colors'

export type IconProps = Omit<SvgIconProps, 'src'>

export function makeIcon(name: string, iconSrc: string, opts?: { defaultColor?: string; defaultSize?: IconSize }) {
	const { defaultColor, defaultSize = 16 } = opts ?? {}
	const component = forwardRef<HTMLSpanElement, IconProps>(({ color, size, ...rest }, ref) => (
		<Icon ref={ref} color={color ?? defaultColor} iconSrc={iconSrc} size={size ?? defaultSize} {...rest} />
	)) as React.ForwardRefFix<HTMLSpanElement, IconProps>
	component.displayName = name
	return memo(component)
}

export const AlertIcon = makeIcon('AlertIcon', AlertIconUrl, { defaultColor: colors.yellow })
export const ArrowLeftThinIcon = makeIcon('ArrowLeftThin', ArrowLeftThinIconUrl)
export const ArrowRightThinIcon = makeIcon('ArrowRightThin', ArrowRightThinIconUrl)
export const BeverageIcon = makeIcon('BeverageIcon', BeverageIconUrl)
export const CarryOnIncludedIcon = makeIcon('CarryOnIncludedIcon', CarryOnIncludedIconUrl)
export const CarryOnNotIncludedIcon = makeIcon('CarryOnNotIncludedIcon', CarryOnNotIncludedIconUrl)
export const ChargeDateIcon = makeIcon('ChargeDateIcon', ChargeDateUrl)
export const CheckCurvyIcon = makeIcon('CheckCurvyIcon', CheckCurvyIconUrl)
export const CheckIcon = makeIcon('CheckIcon', CheckIconUrl)
export const ChevronDownIcon = makeIcon('ChevronDown', ChevronDownUrl)
export const ClockIcon = makeIcon('ClockIcon', ClockIconUrl)
export const CrossIcon = makeIcon('CrossIcon', CrossIconUrl, { defaultColor: colors.brightRed })
export const DollarIcon = makeIcon('DollarIcon', DollarIconUrl, { defaultColor: colors.yellow })
export const DollarCircleIcon = makeIcon('DollarCircleIcon', DollarCircleIconUrl, { defaultColor: colors.yellow })
export const DownloadIcon = makeIcon('DownloadIcon', DownloadIconUrl)
export const EntertainIcon = makeIcon('EntertainIcon', EntertainIconUrl)
export const FeeIdIcon = makeIcon('FeeIdIcon', FeeIdUrl)
export const FlightIcon = makeIcon('FlightIcon', FlightIconUrl)
export const HourGlassIcon = makeIcon('HourGlassIcon', HourGlassUrl)
export const InfoIcon = makeIcon('InfoIcon', InfoIconUrl, { defaultColor: colors.disabledGray })
export const LinkIcon = makeIcon('Link', LinkIconUrl)
export const LinkRoundIcon = makeIcon('LinkRound', LinkRoundIconUrl)
export const LuggageIcon = makeIcon('LuggageIcon', LuggageIconUrl)
export const MealIcon = makeIcon('MealIcon', MealIconUrl)
export const RefundReportsIcon = makeIcon('RefundReportsIcon', RefundReportsUrl)
export const PowerIcon = makeIcon('PowerIcon', PowerIconUrl)
export const ShowIcon = makeIcon('ShowIcon', ShowIconUrl)
export const TicketIcon = makeIcon('Ticket', TicketIconUrl)
export const WiFiIcon = makeIcon('WiFiIcon', WiFiIconUrl)
export const TrainsIcon = makeIcon('TrainsIcon', TrainsIconUrl)
export const DetailsIcon = makeIcon('DetailsIcon', DetailsIconUrl)
export const RoundCheckIcon = makeIcon('RoundCheckIcon', RoundCheckIconUrl)
export const ClipIcon = makeIcon('ClipIcon', ClipIconUrl)
export const CreditCardIcon = makeIcon('CreditCardIcon', CreditCardIconUrl)
export const CardIcon = makeIcon('CardIcon', CardIconUrl)
export const LoyaltyIcon = makeIcon('LoyaltyIcon', LoyaltyIconUrl)
export const InPolicyIcon = makeIcon('InPolicyIcon', InPolicyIconUrl)
export const UtensilsIcon = makeIcon('UtensilsIcon', UtensilsIconUrl)
export const QuestionCircleIcon = makeIcon('QuestionCircleIcon', QuestionCircleIconUrl, {
	defaultColor: colors.disabledGray,
})

export const ManIcon = makeIcon('ManIcon', ManIconUrl)
export const GearIcon = makeIcon('GearIcon', GearIconUrl)
export const MembershipIcon = makeIcon('MembershipIcon', MembershipIconUrl)
export const EnvelopClosedIcon = makeIcon('EnvelopClosedIcon', EnvelopClosedIconUrl)
export const MockIcon = makeIcon('MockIcon', MockIconUrl)
export const SortIcon = makeIcon('SortIcon', SortIconUrl)
export const FilterIcon = makeIcon('FilterIcon', FilterIconUrl)
export const StopIcon = makeIcon('StopIcon', StopIconUrl)
